import React, {useEffect, useState} from 'react';
import {Brain, ChevronDown, ChevronRight} from 'lucide-react';
import {ReasoningItem} from '../../api/types';

/**
 * Collapsible reasoning block: expanded while streaming, auto-collapses on completion.
 */
const ReasoningItemView: React.FC<{item: ReasoningItem}> = ({item}) => {
    const isStreaming = item.status === 'in_progress';
    const [expanded, setExpanded] = useState(isStreaming);
    const [autoCollapsed, setAutoCollapsed] = useState(false);

    useEffect(() => {
        if (!isStreaming && !autoCollapsed) {
            setExpanded(false);
            setAutoCollapsed(true);
        }
    }, [isStreaming, autoCollapsed]);

    if (!item.text) {
        return null;
    }

    return (
        <div className="mb-2 small text-muted">
            <button
                type="button"
                className="btn btn-link btn-sm p-0 text-muted text-decoration-none d-flex align-items-center gap-1"
                onClick={() => setExpanded(value => !value)}
            >
                {expanded ? (
                    <ChevronDown size={14} />
                ) : (
                    <ChevronRight size={14} />
                )}
                <Brain size={14} />
                {isStreaming ? 'Thinking…' : 'Thought process'}
            </button>
            {expanded && (
                <div
                    className="border-start ps-2 mt-1"
                    style={{whiteSpace: 'pre-wrap'}}
                >
                    {item.text}
                </div>
            )}
        </div>
    );
};

export default ReasoningItemView;
